import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";
import i18n, { setLanguage } from "@/i18n";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=authed
  const [checked, setChecked] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      // Sync user's preferred language with i18n
      if (data.preferred_language && data.preferred_language !== i18n.language) {
        setLanguage(data.preferred_language);
      }
    } catch {
      setUser(false);
    } finally {
      setChecked(true);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password, remember_me) => {
    const { data } = await api.post("/auth/login", { email, password, remember_me });
    if (data.token) localStorage.setItem("em_os_token", data.token);
    setUser({ id: data.id, email: data.email, name: data.name, role: data.role });
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* ignore */
    }
    localStorage.removeItem("em_os_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, checked, login, logout, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
